/* eslint-disable react/prop-types */
import React from 'react';

const SearchInput = (props) => (
  <div
    className={`rounded bg-light p-0 popup-search-input d-flex flex-row flex-row-reverse position-relative ${props.className}`}>
    <input
      id={props.id}
      onFocus={props.onFocus}
      type="text"
      onChange={(e) => {
        props.onChange(e);
      }}
      value={props.value}
      onBlur={props.onBlur}
      className="form-control border-1 border-transparent bg-light shadow-none w-100 ps-5 d-flex"
      autoComplete="off"
      placeholder={props.placeholder}
      style={{ height: '2.5rem', lineHeight: '2.5rem' }}
    />
    <i
      style={{ left: 5 }}
      className="position-absolute start-0 top-0 px-3 py-3 icon icon-search-other h-100 d-flex align-items-center justify-content-center text-shadow"
      role="button"
      aria-label="Search"
      tabIndex="-1"
    />
  </div>
);

export default SearchInput;
